import { type JanusCtx, type Row, handBack, itemField, requiredInt } from '../context.js';
import { type JanusInput } from '../janus.js';
import { applyStatusEffect } from './apply-status-effect.js';

/** Apply the ability's status layer through applyStatusEffect(). */
export function applyStatusEffects(ctx: JanusCtx, input: JanusInput, ability: Row, layerName: string, caster: Row, target: Row): void {
  const entries = ctx.read.entries(ability, layerName);
  if (!entries.length) {
    if (ctx.read.has(ability, layerName)) handBack(`apply_status_effects:status-id-not-held:${layerName}:empty-entries`);
    return;
  }
  // stacks_applied: a QUANTITY-group rider adds this many stacks (0 = derive from the id);
  // apply_status_effect ignores it for any other status (lane A8 — was a hand-back)
  const raw = ctx.read.value(ability, 'stacks_applied');
  const stacksApplied = raw == null || raw === '' ? 0 : Math.max(0, requiredInt(raw, 'apply_status_effects:invalid-stacks-applied'));
  for (const entry of entries) {
    let id: string;
    if (layerName === 'spell_concentration') id = 'E7FDB796-26DA-E0F5-8F88-C21FE01D923B';
    else if (typeof entry === 'string') id = entry.split('|')[0] ?? '';
    else if (entry && typeof entry === 'object') id = String(itemField(entry as Row, 'item_id') ?? '');
    else handBack('apply_status_effects:malformed-layer-entry');
    if (!id || id.startsWith('|') || (typeof entry === 'string' && !/^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(entry)))
      handBack(`apply_status_effects:status-id-not-held:${layerName}:invalid-entry`);
    applyStatusEffect(ctx, input, ability, id, layerName, caster, target, undefined, false, true, stacksApplied);
  }
}
